import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';
import InformationStack from '../../../components/stacks/InformationStack';
import { INFORMATION_STACK_CLASS_NAME } from '../../../theme/constants/stack';
import { getStatusLabel } from '../constants';

const InvoiceDetailHeader = ({ invoice }) => {
  const history = useHistory();
  const goBack = () => history.goBack();

  return (
    <Paper
      elevation={0}
      sx={{ border: '1px solid', borderColor: 'gray.A300', borderRadius: 2, p: 2 }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={goBack} color="primary" aria-label="go-back" id="invoice-detail-go-back">
            <ArrowBackIcon />
          </IconButton>
          <Stack>
            <Typography variant="large_1" fontWeight={700} color="gray.A700">
              Factura {invoice?.folio}
            </Typography>
            <Typography variant="small_2" color="text.secondary">
              Revisa con transparencia la información de tu factura operada.
            </Typography>
          </Stack>
        </Stack>
        {invoice?.status && (
          <InformationStack
            text={getStatusLabel(invoice)}
            className={INFORMATION_STACK_CLASS_NAME}
            variant="small_2"
            fontWeight={600}
          />
        )}
      </Stack>
    </Paper>
  );
};

InvoiceDetailHeader.propTypes = {
  invoice: PropTypes.shape({
    folio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    status: PropTypes.string,
  }),
};

InvoiceDetailHeader.defaultProps = {
  invoice: null,
};

export default InvoiceDetailHeader;
